// extracted by mini-css-extract-plugin
export var blockchainSwitcher = "E3WwlCw52aepEG82VXu5";
export var message = "fPx0KWtCbgQRYP7JvA8N";
export var root = "_39CAceLhpLa5XuBH_rbv";
export var swapPageTitle = "oNXi59WBMeFmRRvq65pQ";